/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';

import metadata from './MLCRDriversGoodStudentComponent.metadata.json5';


function MLCRDriversGoodStudentComponent(props) {
    const { driverVM, isModelBridgedAndDefaultedByHVQ } = props;
    const { refreshData } = useDataRefresh();
    const viewModelService = useContext(ViewModelServiceContext);
    const goodStudentTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GoodStudent_ML');

    const minDriverAgeGoodStudent = 14;
    const maxDriverAgeGoodStudent = 24;

    const goodStudentType = () => {
        if (!_.isUndefined(driverVM.goodStudentType_ML) && !_.isUndefined(driverVM.goodStudentType_ML.value))
            return driverVM.goodStudentType_ML.value.code;
    };

    //
    // Good Student
    //
    const getDriverAge = (driverDateOfBirth) => {
        const dob = MLLocalDateUtil.localDate2Date(driverDateOfBirth);
        const today = new Date();
        return MLLocalDateUtil.differenceInYears(today, dob);
    };

    const isGoodStudentVisible = () => {
        if (!driverVM.dateOfBirth.value) {
            return false;
        }
        const driverAge = getDriverAge(driverVM.dateOfBirth.value);
        return !!driverVM.occupation_Ext.value
            && driverVM.occupation_Ext.value.code === 'student'
            && driverAge >= minDriverAgeGoodStudent
            && driverAge <= maxDriverAgeGoodStudent;
    };

    const isGoodStudentOptionVisible = () => {
        return isGoodStudentVisible(driverVM)
            && !!driverVM.isGoodStudent_ML.value;
    };

    //
    // Viewmodel Form
    //
    const handleValueChange = (value, path) => {
        if (path === 'isGoodStudent') {
            driverVM.isGoodStudent_ML.value = value.code === 'true';
            if (value.code === 'false') {
                driverVM.goodStudentType_ML.value = undefined;
            }
        } else if (path === 'goodStudentType') {
            driverVM.goodStudentType_ML.value = goodStudentTypeList.getCode(value.code);
        }
        refreshData();
    }


    const overrideProps = {
        goodStudentContainer: {
            visible: isGoodStudentVisible(driverVM)
        },
        goodStudentOptionContainer: {
            visible: isGoodStudentOptionVisible(driverVM)
        },
        goodStudentWarning: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.isGoodStudent_ML)
        },
        goodStudent: {
            value: {
                code: driverVM.isGoodStudent_ML && driverVM.isGoodStudent_ML.value ? 'true' : 'false'
            }
        },
        goodStudentOption: {
            value: {
                code:  goodStudentType(driverVM)
            }
        }
    };

    const resolvers = {
        resoolveCallbackMap: {
            handleGoodStudentChange: handleValueChange,
            handleGoodStudentOptionChange: handleValueChange
        }
    }

    return (
        <ViewModelForm
            model={driverVM}
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resoolveCallbackMap}
        />
    );

}

MLCRDriversGoodStudentComponent.propTypes = {
    driverVM: PropTypes.shape({}).isRequired,
    isModelBridgedAndDefaultedByHVQ: PropTypes.func
};
MLCRDriversGoodStudentComponent.defaultProps = {
    isModelBridgedAndDefaultedByHVQ: undefined
};
export default withRouter(MLCRDriversGoodStudentComponent);
